/**
 * AllergyService
 * Service for Allergy entity operations
 * Route: api/allergies
 * Controller: AllergiesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * AllergyService
 * Handles allergy CRUD operations (cached lookup table)
 * Maps to /api/allergies endpoint
 */
export class AllergyService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AllergyService.DEFAULT_SERVICE_PATH,
            basePath: AllergyService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AllergyService.DEFAULT_SERVICE_PATH = 'members';
AllergyService.BASE_PATH = 'api/allergies';
//# sourceMappingURL=AllergyService.js.map